<!-- Institute of Design and Innovation (email idi@unm.edu). -->

<!-- User Availability list -->
<template>
  <div class="user-availability page">
    <h1>Availability</h1>

    <div class="user-availability-list">
      <availability-form v-for="user of users" :key="user.id" :user="user" :appointmentTypes="appointmentTypes" v-on:update-availability="updateUser(user, $event)"></availability-form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import appointmentTypeService from '../common/appointmentTypeService'
import userService from '../common/userService'
import { AppointmentTypeDetail } from '../models/appointmentType'
import User from '../models/user'
import AvailabilityForm from '../components/AvailabilityForm.vue'

export default defineComponent({
  name: 'Availability',

  data () {
    return {
      users: [] as Array<User>,
      appointmentTypes: [] as Array<AppointmentTypeDetail>
    }
  },

  mounted () {
    // get all appointment types
    appointmentTypeService.getAll().then(res => {
      this.appointmentTypes = res.data
    })

    // get OSP staff user records
    userService.getOspStaff().then(res => {
      this.users = res.data
    })
  },

  methods: {
    // update availability for user
    updateUser (user, newUser) {
      user.availability = newUser.availability
    }
  },

  components: {
    AvailabilityForm
  }
})
</script>
